module.exports = __webpack_public_path__ + "static/media/yushan7.909616eb.webp";